import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { HeroBannerSlider } from "@/components/HeroBannerSlider";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";
import { useStorefront, useStorefrontConfig } from "@/lib/storefront";
import { loc } from "@/lib/format";
import { useCart } from "@/lib/cart";
import { onlineOrderDestination } from "@/lib/menu-navigation";

export const Route = createFileRoute("/")({
  component: Home,
});

function Home() {
  const { t, lang } = useI18n();
  const bootstrap = useStorefront();
  const config = useStorefrontConfig();
  const { cart } = useCart();
  const orderPath = onlineOrderDestination(bootstrap, cart.orderType?.type);

  return (
    <HeroBannerSlider banners={config.homeHeroBanners} showPagination={false}>
      <div className="relative mx-auto flex min-h-[25rem] w-full max-w-7xl flex-1 flex-col items-center justify-center gap-5 px-4 py-20 text-center sm:min-h-[34rem] sm:px-6 sm:py-24">
        <h1 className="max-w-3xl text-4xl font-black leading-tight text-white sm:text-6xl">
          {loc(config.heroTitle, lang) || t("home.storyTitle")}
        </h1>
        <p className="max-w-2xl text-lg text-white/85">
          {loc(config.heroDescription, lang) || t("home.menuDesc")}
        </p>
        <Button asChild size="xl" variant="gold" className="w-full sm:w-auto">
          <Link to={orderPath}>
            {t("home.cta")}
            <ArrowLeft className="size-5 rtl:rotate-0 ltr:rotate-180" />
          </Link>
        </Button>
      </div>
    </HeroBannerSlider>
  );
}
